<template>
  <section class="filter-category">
    <Heading v-if="!isSubCategory" :level="3">
      {{ getCategoryName(filter) }}
    </Heading>
    <BaseText v-else as="h4" size="sm" :color="NebraskaColors.textSecondary">
      {{ getCategoryName(filter) }}
    </BaseText>
    <component
      :is="filterComponent"
      v-if="!hasSubcategories"
      v-model="filter.modalSelectedOption"
      class="filter-category__options"
      :options="getFilterOptions(filter.filters)"
      :data-testid="`filter-options-${component}`"
      @select-option="selectOption"
    />
    <slot name="sub-categories" />
  </section>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { Heading, FilterList, BaseText } from '@warrenbrasil/nebraska-web';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  EFilterCategoryComponent,
  IFilterCategory,
  IFilterSubcategory,
  IFilterOptions,
  IFilterQuickOptions
} from '../../../../services/types/models/IFilters';

const FilterComponentMap = {
  [EFilterCategoryComponent.Chip]: FilterList,
  [EFilterCategoryComponent.Checkbox]: FilterCheckboxList
};

@Component({
  components: { Heading, BaseText, FilterList, FilterCheckboxList }
})
export default class FilterCategory extends Vue {
  @Prop({ type: Object, required: true })
  filter!: IFilterCategory;

  @Prop({ type: Boolean, default: false, required: false })
  readonly isSubCategory!: boolean;

  @Prop({
    type: String,
    required: false,
    validator: value =>
      Object.keys(FilterComponentMap).some(component => component === value)
  })
  readonly component!: EFilterCategoryComponent;

  readonly NebraskaColors = NebraskaColors;
  options?: Array<unknown>;

  public created() {
    this.options = this.getFilterOptions(this.filter.filters);
  }

  selectOption(option: IFilterQuickOptions) {
    if (option.checked) {
      if (this.filter.modalSelectedOption && option.checked) {
        this.filter.modalSelectedOption?.push(option.value);
      } else {
        this.filter.modalSelectedOption = [];
        this.filter.modalSelectedOption.push(option.value);
      }
    } else {
      this.filter.modalSelectedOption = this.filter.modalSelectedOption?.filter(
        item => item !== option.value
      );
    }
  }

  isFilterChecked(option: string) {
    return this.filter.modalSelectedOption?.includes(option);
  }

  getCategoryName(filter: IFilterCategory | IFilterSubcategory) {
    return 'categoryName' in filter
      ? filter.categoryName
      : filter.subCategoryName;
  }

  getFilterOptions(filters?: IFilterOptions[]) {
    return filters?.map(filter => ({
      checked: this.isFilterChecked(filter.value),
      label: filter.formatted,
      value: filter.value,
      icon: filter.icon
    }));
  }

  get filterComponent() {
    return FilterComponentMap[this.component];
  }

  get hasSubcategories() {
    return this.$slots['sub-categories'];
  }
}
</script>

<style lang="less" scoped>
.filter-category {
  text-align: left;

  &__options {
    margin-top: @size-spacing-x450;

    // TODO: Corrigir os estilos abaixo do FilterList no projeto nebraska-web
    flex-wrap: wrap;
    gap: @size-spacing-x300;

    ::v-deep > li {
      margin-left: 0 !important;
    }
  }
}
</style>
